import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { LoginResultDto } from '../data-models/identity.data.models';
import { SignalrService } from 'src/app/shared/services/signalr.service';
import { SentryService } from 'src/app/shared/services/sentry.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _currentUserCredantials?: LoginResultDto;

  constructor(
    private router: Router,
    private signalrService: SignalrService,
    private sentryService: SentryService
  ) { }

  getCurrentSystemLanguage(): string {
    let language = localStorage.getItem('language');
    if (language) return language;
    else {
      localStorage.setItem('language', 'en-US');
      return 'en-US';
    }
  }
  setLanguage(language: string) {
    localStorage.setItem('language', language);
  }

  get currentUserCredantials(): LoginResultDto {
    if (localStorage.getItem("currentUser")) {
      return JSON.parse(localStorage.getItem("currentUser") as string) as LoginResultDto;
    }
    else
      return undefined!;

  }
  set currentUserCredantials(value: LoginResultDto | undefined) {
    if (value && value.expiryTokenInMinutes) {
      var expiryDate = new Date();
      expiryDate.setMinutes(expiryDate.getMinutes() + value.expiryTokenInMinutes! - 5);
      value.expiryTokenDate = expiryDate;
    }
    this._currentUserCredantials = value == undefined ? value : JSON.parse(JSON.stringify(value));
    localStorage.setItem("currentUser", this._currentUserCredantials ? JSON.stringify(this._currentUserCredantials) : "");

    // Update Sentry user context
    if (value && value.userId) {
      this.sentryService.setUserContext(value.userId, value.email);
    } else {
      this.sentryService.clearUserContext();
    }
  }

  isLoggedIn(): boolean {
    if (this.currentUserCredantials)
      return true;
    else
      return false;
  }

  logout() {
    this.clearLocalStorage();
    this.signalrService.stopConnection();
    this.sentryService.clearUserContext(); // Clear Sentry user context on logout
    this.router.navigate(['/authentication/login']).then(() => {
      window.location.reload();
    });
  }
  clearLocalStorage() {
    this._currentUserCredantials = undefined;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('investTypeId');
    localStorage.removeItem('requestId');
    this.sentryService.clearUserContext(); // Clear Sentry user context
  }




}